import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import initialState from './initialState';

export default {
  namespaced: true,
  state: { ...initialState },
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/panels/index.js